import { useState, useEffect } from 'react';
import { supabase } from '../../../lib/supabase';

// ── Konfigurasi toko — sesuaikan di sini ────────────────────────────
const STORE_NAME  = 'HAPin';    // ← ganti nama toko
const STORE_PHONE = '08xxxxxxxxxx'; // ← ganti nomor toko
// ────────────────────────────────────────────────────────────────────

function fmtDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('id-ID', { day: 'numeric', month: 'short' });
}

function fmtDateFull(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' });
}

function buildReceiptHTML(orders, batchLabel) {
  const validOrders = orders.filter(o => o.status !== 'batal');
  const totalPacks  = validOrders.reduce((s, o) => s + o.qty, 0);
  const totalCOD    = validOrders.reduce((s, o) => s + o.total, 0);
  const isSingle    = orders.length === 1;
  const o           = orders[0];



  const dash = `<tr><td colspan="2" style="font-size:9px;letter-spacing:1px;padding:2px 0">${'-'.repeat(32)}</td></tr>`;

  const header = `
    <tr><td colspan="2" style="text-align:center;font-weight:bold;font-size:13px;padding-bottom:1px">${STORE_NAME}</td></tr>
    <tr><td colspan="2" style="text-align:center;font-size:9px;padding-bottom:4px">${STORE_PHONE}</td></tr>
    ${dash}
    <tr><td colspan="2" style="text-align:center;font-weight:bold;padding:1px 0">${batchLabel}</td></tr>
    <tr><td colspan="2" style="text-align:center;font-size:9px;padding-bottom:3px">${isSingle ? 'STRUK ORDER' : 'REKAP PO BATCH'}</td></tr>
    ${dash}
  `;

  let body = '';
  if (isSingle) {
    body = `
      <tr><td style="padding:1px 0"><b>Nama</b></td><td>: ${o.customer?.name || '-'}</td></tr>
      <tr><td style="padding:1px 0"><b>WA</b></td><td>: ${o.customer?.wa || '-'}</td></tr>
      ${dash}
      <tr><td style="padding:1px 0"><b>Produk</b></td><td>: ${o.po?.product?.name || '-'}</td></tr>
      <tr><td style="padding:1px 0"><b>Qty</b></td><td>: ${o.qty} pack</td></tr>
    <tr><td><b>Metode</b></td><td>: ${o.payment_method === 'non-tunai' ? `Non-Tunai (${o.payment_status === 'paid' ? 'Lunas' : 'Pending'})` : 'COD'}</td></tr>
      <tr><td style="padding:1px 0"><b>Total</b></td><td>: <b>Rp ${(o.total||0).toLocaleString('id-ID')}</b></td></tr>
      <tr><td style="padding:1px 0"><b>Status</b></td><td>: ${o.status.toUpperCase()}</td></tr>
    `;
  } else {
    body = validOrders.map((ord, i) => `
      <tr><td colspan="2" style="padding-top:${i > 0 ? '5px' : '0'};font-weight:bold">${i+1}. ${ord.customer?.name || '-'}</td></tr>
      <tr><td colspan="2" style="padding-left:10px;font-size:9px">${ord.qty} pack &nbsp;&#183;&nbsp; Rp ${(ord.total||0).toLocaleString('id-ID')}</td></tr>
      <tr><td colspan="2" style="padding-left:10px;font-size:8px">${ord.customer?.wa || ''}</td></tr>
    `).join('');
  }

  const footer = `
    ${dash}
    ${!isSingle ? `
      <tr><td>Total Valid</td><td style="text-align:right">${validOrders.length} order</td></tr>
      <tr><td>Total Pack</td><td style="text-align:right">${totalPacks} pack</td></tr>
    ` : ''}
    <tr><td><b>TOTAL</b></td><td style="text-align:right"><b>Rp ${totalCOD.toLocaleString('id-ID')}</b></td></tr>
    ${dash}
    <tr><td colspan="2" style="text-align:center;font-size:9px;padding-top:2px">Terima kasih!</td></tr>
    <tr><td colspan="2" style="text-align:center;font-size:8px">${fmtDateFull(new Date())}</td></tr>
    <tr><td colspan="2" style="padding-bottom:6mm"></td></tr>
  `;

  return `
    <!DOCTYPE html><html><head>
    <meta charset="utf-8"/>
    <style>
      @page { size: 58mm auto; margin: 0; }
      * { box-sizing: border-box; }
      body { font-family: 'Courier New', Courier, monospace; font-size: 10px; color: #000; margin: 0; padding: 2mm; }
      table { width: 100%; border-collapse: collapse; }
      td { vertical-align: top; line-height: 1.4; }
    </style>
    </head><body>
      <table>${header}${body}${footer}</table>
    </body></html>
  `;
}

function printReceipt(orders, batchLabel) {
  const html = buildReceiptHTML(orders, batchLabel);
  const win  = window.open('', '_blank', 'width=240,height=400');
  if (!win) { alert('Izinkan popup untuk mencetak struk.'); return; }
  win.document.write(html);
  win.document.close();
  win.focus();
  win.onload = () => { win.print(); win.close(); };
  setTimeout(() => { try { win.print(); win.close(); } catch(_) {} }, 800);
}

const STATUS_COLORS = {
  pending:   { bg: '#FFF3E0', c: '#E65100' },
  confirmed: { bg: '#E8F5E9', c: '#1B5E20' },
  batal:     { bg: '#FFEBEE', c: '#C62828' },
};

const css = `
  @media (max-width: 640px) {
    .orders-table { display: none !important; }
    .orders-cards { display: block !important; }
    .orders-stats { grid-template-columns: 1fr 1fr !important; }
    .orders-filter { flex-wrap: wrap; }
  }
  @media (min-width: 641px) {
    .orders-cards { display: none !important; }
  }
`;

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [pos, setPOs] = useState([]);
  const [selPO, setSelPO]   = useState('');
  const [search, setSearch]   = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, []);

  async function load() {
    const [ordersRes, posRes] = await Promise.all([
      supabase.from('po_orders').select('*, po:po_batches(date,time_start,area:areas(name),product:products(name,price)), customer:customers(name,wa), referrer:users!referred_by_user_id(name), items:po_order_items(variant_name,variant_price,qty,subtotal)').order('created_at', { ascending: false }),
      supabase.from('po_batches').select('id, date, area:areas(name), product:products(name)').order('date', { ascending: false }),
    ]);
    setOrders(ordersRes.data || []);
    setPOs(posRes.data || []);
    setLoading(false);
  }

  const filtered = orders.filter(o => {
    if (selPO && o.po_id !== selPO) return false;
    if (search) {
      const q = search.toLowerCase();
      const matchName = (o.customer?.name || '').toLowerCase().includes(q);
      const matchWA   = (o.customer?.wa   || '').includes(q);
      const matchId   = (o.id             || '').toLowerCase().includes(q);
      if (!matchName && !matchWA && !matchId) return false;
    }
    return true;
  });
  const validOrders = filtered.filter(o => o.status !== 'batal');
  const totalPacks = validOrders.filter(o =>
    o.payment_method === 'cod' || (o.payment_method === 'non-tunai' && o.payment_status === 'paid')
  ).reduce((s, o) => s + o.qty, 0);
  const totalRevenue = validOrders.filter(o =>
    o.payment_method === 'cod' || (o.payment_method === 'non-tunai' && o.payment_status === 'paid')
  ).reduce((s, o) => s + o.total, 0);

  return (
    <div style={{ padding: 'clamp(16px,4vw,28px) clamp(12px,4vw,24px) 60px' }}>
      <style>{css}</style>
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1.5rem' }}>Order PO</div>
        <div style={{ fontSize: '.82rem', color: 'var(--muted)' }}>{orders.length} order total</div>
      </div>

      {/* Search */}
      <div style={{ position: 'relative', marginBottom: 12 }}>
        <span style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', fontSize: '.9rem', pointerEvents: 'none' }}>🔍</span>
        <input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Cari nama customer, nomor WA, atau ID order..."
          style={{ width: '100%', padding: '8px 12px 8px 34px', borderRadius: 8, border: '1px solid var(--border)', fontSize: '.82rem', outline: 'none', boxSizing: 'border-box', background: 'white' }}
        />
        {search && (
          <button onClick={() => setSearch('')} style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--muted)', fontSize: '.8rem' }}>✕</button>
        )}
      </div>

      <div className="orders-filter" style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16, overflowX: 'auto', paddingBottom: 4 }}>
        <button onClick={() => setSelPO('')}
          style={{ padding: '6px 14px', borderRadius: 20, border: '1px solid var(--border)', background: selPO === '' ? '#CD5226' : 'white', color: selPO === '' ? '#fff' : 'var(--muted)', fontSize: '.78rem', fontFamily: "'DM Sans',sans-serif", whiteSpace: 'nowrap', flexShrink: 0 }}>
          Semua
        </button>
        {pos.map(p => (
          <div key={p.id} style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
            <button onClick={() => setSelPO(p.id)}
              style={{ padding: '6px 14px', borderRadius: 20, border: '1px solid var(--border)', background: selPO === p.id ? '#CD5226' : 'white', color: selPO === p.id ? '#fff' : 'var(--muted)', fontSize: '.78rem', fontFamily: "'DM Sans',sans-serif", whiteSpace: 'nowrap' }}>
              {p.area?.name} · {fmtDate(p.date)}
            </button>
            <button
              title="Print rekap PO ini"
              onClick={() => {
                const batchOrders = orders.filter(o => o.po_id === p.id);
                const label = `${p.area?.name || ''} · ${fmtDate(p.date)}`;
                printReceipt(batchOrders, label);
              }}
              style={{ padding: '6px 9px', borderRadius: 20, border: '1px solid var(--border)', background: 'white', color: 'var(--muted)', fontSize: '.78rem', cursor: 'pointer', whiteSpace: 'nowrap' }}>
              🖨️
            </button>
          </div>
        ))}
      </div>

      <div className="orders-stats" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 16 }}>
        {[['Order', filtered.length], ['Total Pack', totalPacks + ' pack'], ['Total Pendapatan', 'Rp ' + totalRevenue.toLocaleString('id-ID')]].map(([l, v]) => (
          <div key={l} style={{ background: 'white', borderRadius: 'var(--radius)', border: '1px solid var(--border)', padding: '12px 14px' }}>
            <div style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1.2rem' }}>{v}</div>
            <div style={{ fontFamily: "'DM Mono',monospace", fontSize: '.6rem', letterSpacing: '.8px', textTransform: 'uppercase', color: 'var(--muted)', marginTop: 2 }}>{l}</div>
          </div>
        ))}
      </div>

      {/* Desktop table */}
      <div className="orders-table" style={{ background: 'white', borderRadius: 'var(--radius)', border: '1px solid var(--border)', overflow: 'hidden', boxShadow: 'var(--shadow)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '.82rem' }}>
          <thead>
            <tr>
              {['Nama', 'WhatsApp', 'PO', 'Varian', 'Referral', 'Qty', 'Total', 'Pembayaran', 'Tanggal', 'Status', ''].map(h => (
                <th key={h} style={{ background: '#CD5226', color: '#fff', padding: '9px 14px', textAlign: 'left', fontSize: '.66rem', letterSpacing: '.8px', textTransform: 'uppercase', fontWeight: 500 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={8} style={{ padding: '32px', textAlign: 'center', color: 'var(--muted)' }}>Memuat...</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={8} style={{ padding: '32px', textAlign: 'center', color: 'var(--muted)' }}>Belum ada order</td></tr>
            ) : filtered.map(o => {
              const sc = STATUS_COLORS[o.status] || STATUS_COLORS.pending;
              const label = `${o.po?.area?.name || ''} · ${fmtDate(o.po?.date)}`;
              return (
                <tr key={o.id} onMouseEnter={e => e.currentTarget.style.background = '#FDFAF6'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'} style={{ transition: 'background .1s' }}>
                  <td style={{ padding: '9px 14px', borderBottom: '1px solid #F5EEE6' }}><strong>{o.customer?.name}</strong></td>
                  <td style={{ padding: '9px 14px', borderBottom: '1px solid #F5EEE6' }}>
                    <a href={`https://wa.me/62${(o.customer?.wa || '').replace(/^0/,'')}`} target="_blank" rel="noreferrer" style={{ color: '#27AE60', fontFamily: "'DM Mono',monospace", fontSize: '.76rem' }}>{o.customer?.wa}</a>
                  </td>
                  <td style={{ padding: '9px 14px', borderBottom: '1px solid #F5EEE6' }}>
                    <div style={{ fontSize: '.78rem' }}>{o.po?.area?.name}</div>
                    <div style={{ fontSize: '.72rem', color: 'var(--muted)' }}>{fmtDate(o.po?.date)}</div>
                  </td>
                  <td style={{ padding: '9px 14px', borderBottom: '1px solid #F5EEE6' }}>
                    {(o.items || []).filter(i => i.variant_name).length > 0
                      ? (o.items || []).filter(i => i.variant_name).map((i, idx) => (
                          <div key={idx} style={{ fontSize: '.76rem', background: '#EDE7F6', color: '#4527A0', borderRadius: 10, padding: '2px 8px', marginBottom: 2, display: 'inline-block', marginRight: 4 }}>
                            {i.variant_name} ×{i.qty}
                          </div>
                        ))
                      : <span style={{ fontSize: '.76rem', color: 'var(--muted)' }}>—</span>
                    }
                  </td>
                  <td style={{ padding: '9px 14px', borderBottom: '1px solid #F5EEE6' }}>
                    {o.referrer ? (
                      <span style={{ fontSize: '.75rem', background: '#FFF8E7', color: 'var(--brown)', borderRadius: 10, padding: '2px 8px', fontFamily: "'DM Mono',monospace" }}>{o.referrer.name}</span>
                    ) : <span style={{ color: 'var(--muted)', fontSize: '.75rem' }}>—</span>}
                  </td>
                  <td style={{ padding: '9px 14px', borderBottom: '1px solid #F5EEE6' }}><strong>{o.qty}</strong> pack</td>
                  <td style={{ padding: '9px 14px', borderBottom: '1px solid #F5EEE6' }}><strong>Rp {(o.total || 0).toLocaleString('id-ID')}</strong></td>
                  <td style={{ padding: '9px 14px', borderBottom: '1px solid #F5EEE6' }}>
                    {o.payment_method === 'non-tunai' ? (
                      <div>
                        <span style={{ fontSize: '.72rem', background: '#E3F2FD', color: '#0D47A1', borderRadius: 10, padding: '2px 8px', fontFamily: "'DM Mono',monospace" }}>Non-Tunai</span>
                        <div style={{ marginTop: 3 }}>
                          {o.payment_status === 'paid'
                            ? <span style={{ fontSize: '.68rem', background: '#E8F5E9', color: '#1B5E20', borderRadius: 10, padding: '1px 7px' }}>✅ Paid</span>
                            : o.payment_status === 'failed'
                            ? <span style={{ fontSize: '.68rem', background: '#FFEBEE', color: '#C62828', borderRadius: 10, padding: '1px 7px' }}>❌ Failed</span>
                            : <span style={{ fontSize: '.68rem', background: '#FFF8E1', color: '#F57F17', borderRadius: 10, padding: '1px 7px' }}>⏳ Pending</span>
                          }
                        </div>
                      </div>
                    ) : (
                      <span style={{ fontSize: '.72rem', background: '#F3E5F5', color: '#4A148C', borderRadius: 10, padding: '2px 8px', fontFamily: "'DM Mono',monospace" }}>COD</span>
                    )}
                  </td>
                  <td style={{ padding: '9px 14px', borderBottom: '1px solid #F5EEE6', fontSize: '.76rem', color: 'var(--muted)' }}>{fmtDate(o.created_at)}</td>
                  <td style={{ padding: '9px 14px', borderBottom: '1px solid #F5EEE6' }}>
                    <span style={{ background: sc.bg, color: sc.c, borderRadius: 20, padding: '2px 9px', fontSize: '.66rem', fontFamily: "'DM Mono',monospace" }}>{o.status}</span>
                  </td>
                  <td style={{ padding: '9px 14px', borderBottom: '1px solid #F5EEE6' }}>
                    <button onClick={() => printReceipt([o], label)} title="Print struk"
                      style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 8, padding: '3px 8px', cursor: 'pointer', fontSize: '.75rem', color: 'var(--muted)' }}>
                      🖨️
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="orders-cards">
        {loading ? (
          <div style={{ textAlign: 'center', padding: 32, color: 'var(--muted)', fontSize: '.84rem' }}>Memuat...</div>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 32, color: 'var(--muted)', fontSize: '.84rem' }}>Belum ada order</div>
        ) : filtered.map(o => {
          const sc = STATUS_COLORS[o.status] || STATUS_COLORS.pending;
          const label = `${o.po?.area?.name || ''} · ${fmtDate(o.po?.date)}`;
          return (
            <div key={o.id} style={{ background: 'white', borderRadius: 'var(--radius)', border: '1px solid var(--border)', padding: '14px 16px', marginBottom: 10, boxShadow: 'var(--shadow)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                <div>
                  <div style={{ fontWeight: 500, fontSize: '.9rem' }}>{o.customer?.name}</div>
                  <a href={`https://wa.me/62${(o.customer?.wa || '').replace(/^0/,'')}`} target="_blank" rel="noreferrer"
                    style={{ color: '#27AE60', fontFamily: "'DM Mono',monospace", fontSize: '.75rem' }}>{o.customer?.wa}</a>
                </div>
                <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginLeft: 8 }}>
                  <span style={{ background: sc.bg, color: sc.c, borderRadius: 20, padding: '2px 9px', fontSize: '.66rem', fontFamily: "'DM Mono',monospace", whiteSpace: 'nowrap' }}>{o.status}</span>
                  <button onClick={() => printReceipt([o], label)} title="Print struk"
                    style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 8, padding: '3px 7px', cursor: 'pointer', fontSize: '.75rem', color: 'var(--muted)', whiteSpace: 'nowrap' }}>
                    🖨️
                  </button>
                </div>
              </div>
                <div style={{ display: 'flex', gap: 16, fontSize: '.78rem', color: 'var(--muted)', flexWrap: 'wrap' }}>
                <span>📍 {o.po?.area?.name}</span>
                <span>📅 {fmtDate(o.po?.date)}</span>
                {(o.items || []).filter(i => i.variant_name).map((i, idx) => (
                  <span key={idx} style={{ background: '#EDE7F6', color: '#4527A0', borderRadius: 10, padding: '1px 8px', fontSize: '.74rem' }}>
                    {i.variant_name} ×{i.qty}
                  </span>
                ))}
                {o.referrer && <span style={{ background: '#FFF8E7', color: 'var(--brown)', borderRadius: 10, padding: '1px 8px', fontSize: '.72rem', fontFamily: "'DM Mono',monospace" }}>ref: {o.referrer.name}</span>}
                <span>📦 <strong style={{ color: 'var(--dark)' }}>{o.qty} pack</strong></span>
                <span>💰 <strong style={{ color: 'var(--brown)' }}>Rp {(o.total || 0).toLocaleString('id-ID')}</strong></span>
                {o.payment_method === 'non-tunai'
                  ? <span style={{ background: '#E3F2FD', color: '#0D47A1', borderRadius: 10, padding: '1px 8px', fontSize: '.72rem' }}>
                      Non-Tunai · {o.payment_status === 'paid' ? '✅ Lunas' : o.payment_status === 'failed' ? '❌ Gagal' : '⏳ Pending'}
                    </span>
                  : <span style={{ background: '#F3E5F5', color: '#4A148C', borderRadius: 10, padding: '1px 8px', fontSize: '.72rem' }}>COD</span>
                }
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
